var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "d-flex justify-content-center mb-1" },
      [
        _vm.loadingSpinner
          ? _c("b-spinner", {
              staticStyle: { width: "3rem", height: "3rem" },
              attrs: { variant: "success", span: "Spinning", block: "" },
            })
          : _vm._e(),
      ],
      1
    ),
    !_vm.loadingSpinner
      ? _c(
          "section",
          { staticClass: "invoice-add-wrapper" },
          [
            _c(
              "b-row",
              { staticClass: "invoice-add" },
              [
                _c(
                  "b-col",
                  { attrs: { cols: "12", xl: "9", md: "8" } },
                  [
                    _c("validation-observer", {
                      ref: "purchaseorder",
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (ref) {
                              var invalid = ref.invalid
                              return [
                                _c(
                                  "b-form",
                                  {
                                    on: {
                                      submit: function ($event) {
                                        $event.preventDefault()
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "b-card",
                                      {
                                        staticClass: "invoice-preview-card",
                                        attrs: { "no-body": "" },
                                      },
                                      [
                                        _c(
                                          "b-card-body",
                                          {
                                            staticClass: "invoice-padding pb-0",
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "d-flex flex-column flex-md-row align-items-start justify-content-between invoice-spacing",
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "d-flex flex-column align-items-start me-md-3 mb-2 mb-md-0",
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      { staticClass: "mb-2" },
                                                      [_c("Logo")],
                                                      1
                                                    ),
                                                    _c(
                                                      "div",
                                                      { staticClass: "mb-1" },
                                                      [_c("CompanyName")],
                                                      1
                                                    ),
                                                    _c(
                                                      "div",
                                                      [_c("Address")],
                                                      1
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "invoice-number-date mt-md-0 mt-2 flex-grow-1",
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "d-flex align-items-center justify-content-md-end mb-1",
                                                      },
                                                      [
                                                        _c(
                                                          "h4",
                                                          {
                                                            staticClass:
                                                              "invoice-title",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "Purchase Invoice"
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "d-flex align-items-center justify-content-md-end mb-1 ",
                                                      },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "title",
                                                          },
                                                          [_vm._v("Date:")]
                                                        ),
                                                        _c("flat-pickr", {
                                                          staticClass:
                                                            "form-control invoice-edit-input ms-2",
                                                          attrs: {
                                                            config:
                                                              _vm.config.wrap,
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.issuedDate,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.issuedDate =
                                                                $$v
                                                            },
                                                            expression:
                                                              "issuedDate",
                                                          },
                                                        }),
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "d-flex align-items-center justify-content-md-end",
                                                      },
                                                      [
                                                        _c(
                                                          "validation-provider",
                                                          {
                                                            attrs: {
                                                              rules: "required",
                                                              name: "Due Date",
                                                              vid: "Due Date",
                                                            },
                                                            scopedSlots: _vm._u(
                                                              [
                                                                {
                                                                  key: "default",
                                                                  fn: function (
                                                                    ref
                                                                  ) {
                                                                    var errors =
                                                                      ref.errors
                                                                    return [
                                                                      _c(
                                                                        "div",
                                                                        {
                                                                          staticClass:
                                                                            "d-flex align-items-start",
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "span",
                                                                            {
                                                                              staticClass:
                                                                                "title mt-1",
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                "Due Date:*"
                                                                              ),
                                                                            ]
                                                                          ),
                                                                          _c(
                                                                            "div",
                                                                            {
                                                                              staticClass:
                                                                                "ms-2",
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "flat-pickr",
                                                                                {
                                                                                  class:
                                                                                    [
                                                                                      {
                                                                                        "is-invalid":
                                                                                          errors.length,
                                                                                      },
                                                                                      "form-control invoice-edit-input",
                                                                                    ],
                                                                                  attrs:
                                                                                    {
                                                                                      config:
                                                                                        _vm
                                                                                          .configDue
                                                                                          .wrap,
                                                                                      placeholder:
                                                                                        "Due Date",
                                                                                    },
                                                                                  model:
                                                                                    {
                                                                                      value:
                                                                                        _vm.dueDate,
                                                                                      callback:
                                                                                        function (
                                                                                          $$v
                                                                                        ) {
                                                                                          _vm.dueDate =
                                                                                            $$v
                                                                                        },
                                                                                      expression:
                                                                                        "dueDate",
                                                                                    },
                                                                                }
                                                                              ),
                                                                              errors.length
                                                                                ? _c(
                                                                                    "small",
                                                                                    {
                                                                                      staticClass:
                                                                                        "text-danger",
                                                                                    },
                                                                                    [
                                                                                      _vm._v(
                                                                                        " " +
                                                                                          _vm._s(
                                                                                            errors[0]
                                                                                          ) +
                                                                                          " "
                                                                                      ),
                                                                                    ]
                                                                                  )
                                                                                : _vm._e(),
                                                                            ],
                                                                            1
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  },
                                                                },
                                                              ],
                                                              null,
                                                              true
                                                            ),
                                                          }
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "d-flex align-items-center justify-content-md-end mt-3",
                                                      },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "title",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "Supplier Reference:"
                                                            ),
                                                          ]
                                                        ),
                                                        _c("input", {
                                                          directives: [
                                                            {
                                                              name: "model",
                                                              rawName:
                                                                "v-model",
                                                              value:
                                                                _vm.supplierReference,
                                                              expression:
                                                                "supplierReference",
                                                            },
                                                          ],
                                                          staticClass:
                                                            "form-control invoice-edit-input ms-2",
                                                          attrs: {
                                                            type: "text",
                                                            placeholder:
                                                              "Enter Supplier Reference (Optional)",
                                                          },
                                                          domProps: {
                                                            value:
                                                              _vm.supplierReference,
                                                          },
                                                          on: {
                                                            input: function (
                                                              $event
                                                            ) {
                                                              if (
                                                                $event.target
                                                                  .composing
                                                              ) {
                                                                return
                                                              }
                                                              _vm.supplierReference =
                                                                $event.target.value
                                                            },
                                                          },
                                                        }),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _c("hr", {
                                          staticClass: "invoice-spacing",
                                        }),
                                        _c(
                                          "b-card-body",
                                          {
                                            staticClass: "invoice-padding pt-0",
                                          },
                                          [
                                            _c(
                                              "b-row",
                                              {
                                                staticClass: "invoice-spacing",
                                              },
                                              [
                                                _c(
                                                  "b-col",
                                                  {
                                                    staticClass: "mb-lg-1",
                                                    attrs: {
                                                      cols: "6",
                                                      xl: "6",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "h6",
                                                      { staticClass: "mb-2" },
                                                      [
                                                        _vm._v(
                                                          "Choose Supplier:*"
                                                        ),
                                                      ]
                                                    ),
                                                    _c("validation-provider", {
                                                      attrs: {
                                                        rules: "required",
                                                        name: "Supplier",
                                                        vid: "supplierId",
                                                      },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "default",
                                                            fn: function (ref) {
                                                              var errors =
                                                                ref.errors
                                                              return [
                                                                _c(
                                                                  "b-form-select",
                                                                  {
                                                                    attrs: {
                                                                      options:
                                                                        _vm.optionsCustomer,
                                                                      placeholder:
                                                                        "select supplier",
                                                                    },
                                                                    on: {
                                                                      change:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.supplierSelected(
                                                                            _vm.supplierId
                                                                          )
                                                                        },
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        _vm.supplierId,
                                                                      callback:
                                                                        function (
                                                                          $$v
                                                                        ) {
                                                                          _vm.supplierId =
                                                                            $$v
                                                                        },
                                                                      expression:
                                                                        "supplierId",
                                                                    },
                                                                  }
                                                                ),
                                                                errors.length
                                                                  ? _c(
                                                                      "small",
                                                                      {
                                                                        staticClass:
                                                                          "text-danger",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            errors[0]
                                                                          )
                                                                        ),
                                                                      ]
                                                                    )
                                                                  : _vm._e(),
                                                              ]
                                                            },
                                                          },
                                                        ],
                                                        null,
                                                        true
                                                      ),
                                                    }),
                                                    _vm.whenSelected !== null
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass: "mt-1",
                                                          },
                                                          [
                                                            _c(
                                                              "b-card-text",
                                                              {
                                                                staticClass:
                                                                  "mb-25",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      _vm
                                                                        .whenSelected
                                                                        .name
                                                                    ) +
                                                                    " "
                                                                ),
                                                              ]
                                                            ),
                                                            _c(
                                                              "b-card-text",
                                                              {
                                                                staticClass:
                                                                  "mb-25",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      _vm
                                                                        .whenSelected
                                                                        .email
                                                                    ) +
                                                                    " "
                                                                ),
                                                              ]
                                                            ),
                                                            _c(
                                                              "b-card-text",
                                                              {
                                                                staticClass:
                                                                  "mb-25",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      _vm
                                                                        .whenSelected
                                                                        .address
                                                                    ) +
                                                                    " "
                                                                ),
                                                              ]
                                                            ),
                                                            _c(
                                                              "b-card-text",
                                                              {
                                                                staticClass:
                                                                  "mb-25",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      _vm
                                                                        .whenSelected
                                                                        .phoneNumber
                                                                    ) +
                                                                    " "
                                                                ),
                                                              ]
                                                            ),
                                                            _c(
                                                              "b-card-text",
                                                              {
                                                                staticClass:
                                                                  "mb-0",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      _vm
                                                                        .whenSelected
                                                                        .contactPerson
                                                                    ) +
                                                                    " "
                                                                ),
                                                              ]
                                                            ),
                                                          ],
                                                          1
                                                        )
                                                      : _vm._e(),
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "b-col",
                                                  {
                                                    staticClass: "mb-lg-1",
                                                    attrs: {
                                                      cols: "6",
                                                      xl: "6",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "h6",
                                                      { staticClass: "mb-2" },
                                                      [
                                                        _vm._v(
                                                          "Choose Warehouse:*"
                                                        ),
                                                      ]
                                                    ),
                                                    _c("validation-provider", {
                                                      attrs: {
                                                        rules: "required",
                                                        name: "Warehouse",
                                                        vid: "warehouseId",
                                                      },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "default",
                                                            fn: function (ref) {
                                                              var errors =
                                                                ref.errors
                                                              return [
                                                                _c(
                                                                  "b-form-select",
                                                                  {
                                                                    attrs: {
                                                                      placeholder:
                                                                        "select warehouse",
                                                                      options:
                                                                        _vm.optionsWarehouse,
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        _vm.warehouseId,
                                                                      callback:
                                                                        function (
                                                                          $$v
                                                                        ) {
                                                                          _vm.warehouseId =
                                                                            $$v
                                                                        },
                                                                      expression:
                                                                        "warehouseId",
                                                                    },
                                                                  }
                                                                ),
                                                                errors.length
                                                                  ? _c(
                                                                      "small",
                                                                      {
                                                                        staticClass:
                                                                          "text-danger",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            errors[0]
                                                                          )
                                                                        ),
                                                                      ]
                                                                    )
                                                                  : _vm._e(),
                                                              ]
                                                            },
                                                          },
                                                        ],
                                                        null,
                                                        true
                                                      ),
                                                    }),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "b-card-body",
                                          { staticClass: "invoice-padding" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                ref: "form",
                                                staticClass: "repeater-form",
                                                style: { height: _vm.trHeight },
                                              },
                                              _vm._l(
                                                _vm.invoiceData.items,
                                                function (item, index) {
                                                  return _c(
                                                    "b-row",
                                                    {
                                                      key: index,
                                                      ref: "row",
                                                      refInFor: true,
                                                      staticClass: "pb-2",
                                                    },
                                                    [
                                                      _c(
                                                        "b-col",
                                                        {
                                                          attrs: { cols: "12" },
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "d-flex border rounded",
                                                            },
                                                            [
                                                              _c(
                                                                "b-row",
                                                                {
                                                                  staticClass:
                                                                    "flex-grow-1 p-2",
                                                                },
                                                                [
                                                                  _c(
                                                                    "b-col",
                                                                    {
                                                                      attrs: {
                                                                        cols: "12",
                                                                        lg: "6",
                                                                      },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "label",
                                                                        {
                                                                          staticClass:
                                                                            "static-label",
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "Items*"
                                                                          ),
                                                                        ]
                                                                      ),
                                                                      _vm.newProd
                                                                        ? _c(
                                                                            "div",
                                                                            {
                                                                              staticClass:
                                                                                "d-flex justify-content-center",
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "b-spinner",
                                                                                {
                                                                                  attrs:
                                                                                    {
                                                                                      variant:
                                                                                        "primary",
                                                                                    },
                                                                                }
                                                                              ),
                                                                            ],
                                                                            1
                                                                          )
                                                                        : _c(
                                                                            "div",
                                                                            {
                                                                              staticClass:
                                                                                "d-flex",
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "div",
                                                                                {
                                                                                  staticClass:
                                                                                    "flex-grow-1 mr-1",
                                                                                },
                                                                                [
                                                                                  _c(
                                                                                    "validation-provider",
                                                                                    {
                                                                                      attrs:
                                                                                        {
                                                                                          rules:
                                                                                            "required",
                                                                                          name: "Item",
                                                                                          vid:
                                                                                            "Item_" +
                                                                                            index,
                                                                                        },
                                                                                      scopedSlots:
                                                                                        _vm._u(
                                                                                          [
                                                                                            {
                                                                                              key: "default",
                                                                                              fn: function (
                                                                                                ref
                                                                                              ) {
                                                                                                var errors =
                                                                                                  ref.errors
                                                                                                return [
                                                                                                  _c(
                                                                                                    "v-select",
                                                                                                    {
                                                                                                      class:
                                                                                                        [
                                                                                                          {
                                                                                                            "is-invalid":
                                                                                                              errors.length,
                                                                                                          },
                                                                                                          "item-selector-title",
                                                                                                        ],
                                                                                                      attrs:
                                                                                                        {
                                                                                                          options:
                                                                                                            _vm.optionsProduct,
                                                                                                          label:
                                                                                                            "itemTitle",
                                                                                                          dir: _vm
                                                                                                            .$store
                                                                                                            .state
                                                                                                            .appConfig
                                                                                                            .isRTL
                                                                                                            ? "rtl"
                                                                                                            : "ltr",
                                                                                                          clearable: false,
                                                                                                          searchable: true,
                                                                                                          placeholder:
                                                                                                            "Select Item",
                                                                                                        },
                                                                                                      on: {
                                                                                                        input:
                                                                                                          function (
                                                                                                            val
                                                                                                          ) {
                                                                                                            return _vm.updateItemForm(
                                                                                                              index,
                                                                                                              val
                                                                                                            )
                                                                                                          },
                                                                                                      },
                                                                                                      scopedSlots:
                                                                                                        _vm._u(
                                                                                                          [
                                                                                                            {
                                                                                                              key: "option",
                                                                                                              fn: function (
                                                                                                                ref
                                                                                                              ) {
                                                                                                                var itemTitle =
                                                                                                                  ref.itemTitle
                                                                                                                var categoryName =
                                                                                                                  ref.categoryName
                                                                                                                var subCategoryName =
                                                                                                                  ref.subCategoryName
                                                                                                                return [
                                                                                                                  _c(
                                                                                                                    "div",
                                                                                                                    {
                                                                                                                      staticStyle:
                                                                                                                        {
                                                                                                                          display:
                                                                                                                            "flex",
                                                                                                                          "flex-direction":
                                                                                                                            "column",
                                                                                                                        },
                                                                                                                    },
                                                                                                                    [
                                                                                                                      _c(
                                                                                                                        "span",
                                                                                                                        [
                                                                                                                          _vm._v(
                                                                                                                            _vm._s(
                                                                                                                              itemTitle
                                                                                                                            )
                                                                                                                          ),
                                                                                                                        ]
                                                                                                                      ),
                                                                                                                      _c(
                                                                                                                        "span",
                                                                                                                        [
                                                                                                                          _vm._v(
                                                                                                                            _vm._s(
                                                                                                                              categoryName ||
                                                                                                                                "-"
                                                                                                                            ) +
                                                                                                                              " : " +
                                                                                                                              _vm._s(
                                                                                                                                subCategoryName ||
                                                                                                                                  "-"
                                                                                                                              )
                                                                                                                          ),
                                                                                                                        ]
                                                                                                                      ),
                                                                                                                    ]
                                                                                                                  ),
                                                                                                                ]
                                                                                                              },
                                                                                                            },
                                                                                                          ],
                                                                                                          null,
                                                                                                          true
                                                                                                        ),
                                                                                                      model:
                                                                                                        {
                                                                                                          value:
                                                                                                            item.id,
                                                                                                          callback:
                                                                                                            function (
                                                                                                              $$v
                                                                                                            ) {
                                                                                                              _vm.$set(
                                                                                                                item,
                                                                                                                "id",
                                                                                                                $$v
                                                                                                              )
                                                                                                            },
                                                                                                          expression:
                                                                                                            "item.id",
                                                                                                        },
                                                                                                    }
                                                                                                  ),
                                                                                                  errors.length
                                                                                                    ? _c(
                                                                                                        "small",
                                                                                                        {
                                                                                                          staticClass:
                                                                                                            "text-danger",
                                                                                                        },
                                                                                                        [
                                                                                                          _vm._v(
                                                                                                            _vm._s(
                                                                                                              errors[0]
                                                                                                            )
                                                                                                          ),
                                                                                                        ]
                                                                                                      )
                                                                                                    : _vm._e(),
                                                                                                ]
                                                                                              },
                                                                                            },
                                                                                          ],
                                                                                          null,
                                                                                          true
                                                                                        ),
                                                                                    }
                                                                                  ),
                                                                                ],
                                                                                1
                                                                              ),
                                                                              _c(
                                                                                "div",
                                                                                {
                                                                                  attrs:
                                                                                    {
                                                                                      "d-flex":
                                                                                        "",
                                                                                    },
                                                                                },
                                                                                [
                                                                                  _c(
                                                                                    "b-button",
                                                                                    {
                                                                                      directives:
                                                                                        [
                                                                                          {
                                                                                            name: "ripple",
                                                                                            rawName:
                                                                                              "v-ripple.400",
                                                                                            value:
                                                                                              "rgba(113, 102, 240, 0.15)",
                                                                                            expression:
                                                                                              "'rgba(113, 102, 240, 0.15)'",
                                                                                            modifiers:
                                                                                              {
                                                                                                400: true,
                                                                                              },
                                                                                          },
                                                                                          {
                                                                                            name: "b-modal",
                                                                                            rawName:
                                                                                              "v-b-modal.modal-addProduct",
                                                                                            modifiers:
                                                                                              {
                                                                                                "modal-addProduct": true,
                                                                                              },
                                                                                          },
                                                                                        ],
                                                                                      staticClass:
                                                                                        "mb-2",
                                                                                      attrs:
                                                                                        {
                                                                                          variant:
                                                                                            "primary",
                                                                                          size: "md",
                                                                                        },
                                                                                    },
                                                                                    [
                                                                                      _vm._v(
                                                                                        " + "
                                                                                      ),
                                                                                    ]
                                                                                  ),
                                                                                ],
                                                                                1
                                                                              ),
                                                                            ]
                                                                          ),
                                                                    ]
                                                                  ),
                                                                  _c(
                                                                    "b-col",
                                                                    {
                                                                      attrs: {
                                                                        cols: "12",
                                                                        lg: "2",
                                                                      },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "label",
                                                                        {
                                                                          staticClass:
                                                                            "static-label",
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "Unit Price (Rs)"
                                                                          ),
                                                                        ]
                                                                      ),
                                                                      _c(
                                                                        "validation-provider",
                                                                        {
                                                                          attrs:
                                                                            {
                                                                              rules:
                                                                                "required|min_value:0|max_value:100000000",
                                                                              name: "Unit Price",
                                                                              vid:
                                                                                "UnitPrice_" +
                                                                                index,
                                                                            },
                                                                          scopedSlots:
                                                                            _vm._u(
                                                                              [
                                                                                {
                                                                                  key: "default",
                                                                                  fn: function (
                                                                                    ref
                                                                                  ) {
                                                                                    var errors =
                                                                                      ref.errors
                                                                                    return [
                                                                                      _c(
                                                                                        "b-form-input",
                                                                                        {
                                                                                          attrs:
                                                                                            {
                                                                                              type: "number",
                                                                                              max: 100000000,
                                                                                            },
                                                                                          on: {
                                                                                            keypress:
                                                                                              function (
                                                                                                $event
                                                                                              ) {
                                                                                                return _vm.allowOnlyNumbers(
                                                                                                  $event
                                                                                                )
                                                                                              },
                                                                                          },
                                                                                          model:
                                                                                            {
                                                                                              value:
                                                                                                item.purchase,
                                                                                              callback:
                                                                                                function (
                                                                                                  $$v
                                                                                                ) {
                                                                                                  _vm.$set(
                                                                                                    item,
                                                                                                    "purchase",
                                                                                                    $$v
                                                                                                  )
                                                                                                },
                                                                                              expression:
                                                                                                "item.purchase",
                                                                                            },
                                                                                        }
                                                                                      ),
                                                                                      errors.length
                                                                                        ? _c(
                                                                                            "small",
                                                                                            {
                                                                                              staticClass:
                                                                                                "text-danger",
                                                                                            },
                                                                                            [
                                                                                              _vm._v(
                                                                                                " " +
                                                                                                  _vm._s(
                                                                                                    errors[0]
                                                                                                  ) +
                                                                                                  " "
                                                                                              ),
                                                                                            ]
                                                                                          )
                                                                                        : _vm._e(),
                                                                                    ]
                                                                                  },
                                                                                },
                                                                              ],
                                                                              null,
                                                                              true
                                                                            ),
                                                                        }
                                                                      ),
                                                                    ],
                                                                    1
                                                                  ),
                                                                  _c(
                                                                    "b-col",
                                                                    {
                                                                      attrs: {
                                                                        cols: "12",
                                                                        lg: "2",
                                                                      },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "label",
                                                                        {
                                                                          staticClass:
                                                                            "static-label",
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "VAT (%)"
                                                                          ),
                                                                        ]
                                                                      ),
                                                                      _c(
                                                                        "validation-provider",
                                                                        {
                                                                          attrs:
                                                                            {
                                                                              name: "VAT",
                                                                              rules:
                                                                                "required|between:0,100",
                                                                            },
                                                                          scopedSlots:
                                                                            _vm._u(
                                                                              [
                                                                                {
                                                                                  key: "default",
                                                                                  fn: function (
                                                                                    ref
                                                                                  ) {
                                                                                    var errors =
                                                                                      ref.errors
                                                                                    return [
                                                                                      _c(
                                                                                        "b-form-input",
                                                                                        {
                                                                                          attrs:
                                                                                            {
                                                                                              type: "number",
                                                                                              min: "0",
                                                                                              max: "100",
                                                                                            },
                                                                                          on: {
                                                                                            keypress:
                                                                                              function (
                                                                                                $event
                                                                                              ) {
                                                                                                return _vm.allowOnlyNumbers(
                                                                                                  $event
                                                                                                )
                                                                                              },
                                                                                            wheel:
                                                                                              function (
                                                                                                $event
                                                                                              ) {
                                                                                                return _vm.allowOnlyNumbers(
                                                                                                  $event
                                                                                                )
                                                                                              },
                                                                                          },
                                                                                          model:
                                                                                            {
                                                                                              value:
                                                                                                item.tax,
                                                                                              callback:
                                                                                                function (
                                                                                                  $$v
                                                                                                ) {
                                                                                                  _vm.$set(
                                                                                                    item,
                                                                                                    "tax",
                                                                                                    $$v
                                                                                                  )
                                                                                                },
                                                                                              expression:
                                                                                                "item.tax",
                                                                                            },
                                                                                        }
                                                                                      ),
                                                                                      _c(
                                                                                        "small",
                                                                                        {
                                                                                          staticClass:
                                                                                            "text-danger",
                                                                                        },
                                                                                        [
                                                                                          _vm._v(
                                                                                            " " +
                                                                                              _vm._s(
                                                                                                errors[0]
                                                                                                  ? "Please enter a valid VAT percentage."
                                                                                                  : ""
                                                                                              ) +
                                                                                              " "
                                                                                          ),
                                                                                        ]
                                                                                      ),
                                                                                    ]
                                                                                  },
                                                                                },
                                                                              ],
                                                                              null,
                                                                              true
                                                                            ),
                                                                        }
                                                                      ),
                                                                    ],
                                                                    1
                                                                  ),
                                                                  _c(
                                                                    "b-col",
                                                                    {
                                                                      attrs: {
                                                                        cols: "12",
                                                                        lg: "2",
                                                                      },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "label",
                                                                        {
                                                                          staticClass:
                                                                            "static-label",
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "Qty*"
                                                                          ),
                                                                        ]
                                                                      ),
                                                                      _c(
                                                                        "validation-provider",
                                                                        {
                                                                          attrs:
                                                                            {
                                                                              rules:
                                                                                "required|min_value:1",
                                                                              name: "Quantity",
                                                                              vid:
                                                                                "Quantity_" +
                                                                                index,
                                                                            },
                                                                          scopedSlots:
                                                                            _vm._u(
                                                                              [
                                                                                {
                                                                                  key: "default",
                                                                                  fn: function (
                                                                                    ref
                                                                                  ) {
                                                                                    var errors =
                                                                                      ref.errors
                                                                                    return [
                                                                                      _c(
                                                                                        "b-form-input",
                                                                                        {
                                                                                          on: {
                                                                                            keypress:
                                                                                              function (
                                                                                                $event
                                                                                              ) {
                                                                                                return _vm.allowOnlyNumbers(
                                                                                                  $event
                                                                                                )
                                                                                              },
                                                                                          },
                                                                                          model:
                                                                                            {
                                                                                              value:
                                                                                                item.qty,
                                                                                              callback:
                                                                                                function (
                                                                                                  $$v
                                                                                                ) {
                                                                                                  _vm.$set(
                                                                                                    item,
                                                                                                    "qty",
                                                                                                    $$v
                                                                                                  )
                                                                                                },
                                                                                              expression:
                                                                                                "item.qty",
                                                                                            },
                                                                                        }
                                                                                      ),
                                                                                      errors.length
                                                                                        ? _c(
                                                                                            "small",
                                                                                            {
                                                                                              staticClass:
                                                                                                "text-danger",
                                                                                            },
                                                                                            [
                                                                                              _vm._v(
                                                                                                _vm._s(
                                                                                                  errors[0]
                                                                                                )
                                                                                              ),
                                                                                            ]
                                                                                          )
                                                                                        : _vm._e(),
                                                                                    ]
                                                                                  },
                                                                                },
                                                                              ],
                                                                              null,
                                                                              true
                                                                            ),
                                                                        }
                                                                      ),
                                                                    ],
                                                                    1
                                                                  ),
                                                                  _c(
                                                                    "b-col",
                                                                    {
                                                                      attrs: {
                                                                        cols: "12",
                                                                        lg: "2",
                                                                      },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "div",
                                                                        {
                                                                          staticClass:
                                                                            "mb-1",
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "b-button",
                                                                            {
                                                                              attrs:
                                                                                {
                                                                                  variant:
                                                                                    "danger",
                                                                                  size: "sm",
                                                                                },
                                                                              on: {
                                                                                click:
                                                                                  function (
                                                                                    $event
                                                                                  ) {
                                                                                    return _vm.removeItem(
                                                                                      index
                                                                                    )
                                                                                  },
                                                                              },
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                " Remove "
                                                                              ),
                                                                            ]
                                                                          ),
                                                                        ],
                                                                        1
                                                                      ),
                                                                    ]
                                                                  ),
                                                                  _c(
                                                                    "b-col",
                                                                    {
                                                                      attrs: {
                                                                        cols: "12",
                                                                        lg: "12",
                                                                      },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "span",
                                                                        {
                                                                          staticClass:
                                                                            "d-inline d-lg-none",
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "Description"
                                                                          ),
                                                                        ]
                                                                      ),
                                                                      _c(
                                                                        "b-form-textarea",
                                                                        {
                                                                          staticClass:
                                                                            "mb-2 mb-lg-0",
                                                                          model:
                                                                            {
                                                                              value:
                                                                                item.description,
                                                                              callback:
                                                                                function (
                                                                                  $$v
                                                                                ) {
                                                                                  _vm.$set(
                                                                                    item,
                                                                                    "description",
                                                                                    $$v
                                                                                  )
                                                                                },
                                                                              expression:
                                                                                "item.description",
                                                                            },
                                                                        }
                                                                      ),
                                                                    ],
                                                                    1
                                                                  ),
                                                                ],
                                                                1
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  )
                                                }
                                              ),
                                              1
                                            ),
                                            _c(
                                              "b-button",
                                              {
                                                directives: [
                                                  {
                                                    name: "ripple",
                                                    rawName: "v-ripple.400",
                                                    value:
                                                      "rgba(255, 255, 255, 0.15)",
                                                    expression:
                                                      "'rgba(255, 255, 255, 0.15)'",
                                                    modifiers: { 400: true },
                                                  },
                                                ],
                                                attrs: {
                                                  size: "sm",
                                                  variant: "primary",
                                                },
                                                on: {
                                                  click:
                                                    _vm.addNewItemInItemForm,
                                                },
                                              },
                                              [_vm._v(" Add Item ")]
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "b-card-body",
                                          {
                                            staticClass: "invoice-padding pb-0",
                                          },
                                          [
                                            _c(
                                              "b-row",
                                              [
                                                _c(
                                                  "b-col",
                                                  {
                                                    staticClass:
                                                      "mt-md-0 mt-3 d-flex align-items-center",
                                                    attrs: {
                                                      cols: "12",
                                                      sm: "6",
                                                      order: "2",
                                                      "order-md": "1",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        attrs: {
                                                          for: "invoice-data-sales-person",
                                                        },
                                                      },
                                                      [_vm._v("Issuer:*")]
                                                    ),
                                                    _c("validation-provider", {
                                                      attrs: {
                                                        rules: "required",
                                                        name: "Sales Person",
                                                        vid: "Sales Person",
                                                      },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "default",
                                                            fn: function (ref) {
                                                              var errors =
                                                                ref.errors
                                                              return [
                                                                _c(
                                                                  "b-form-select",
                                                                  {
                                                                    attrs: {
                                                                      options:
                                                                        _vm.optionsSalesPerson,
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        _vm.salesPersonId,
                                                                      callback:
                                                                        function (
                                                                          $$v
                                                                        ) {
                                                                          _vm.salesPersonId =
                                                                            $$v
                                                                        },
                                                                      expression:
                                                                        "salesPersonId",
                                                                    },
                                                                  }
                                                                ),
                                                                errors.length
                                                                  ? _c(
                                                                      "small",
                                                                      {
                                                                        staticClass:
                                                                          "text-danger",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            errors[0]
                                                                          )
                                                                        ),
                                                                      ]
                                                                    )
                                                                  : _vm._e(),
                                                              ]
                                                            },
                                                          },
                                                        ],
                                                        null,
                                                        true
                                                      ),
                                                    }),
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "b-col",
                                                  {
                                                    staticClass:
                                                      "mt-md-6 d-flex justify-content-end",
                                                    attrs: {
                                                      cols: "12",
                                                      sm: "6",
                                                      order: "1",
                                                      "order-md": "2",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "invoice-total-wrapper",
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "invoice-total-item",
                                                          },
                                                          [
                                                            _c(
                                                              "p",
                                                              {
                                                                staticClass:
                                                                  "invoice-total-title",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "Subtotal:"
                                                                ),
                                                              ]
                                                            ),
                                                            _c(
                                                              "p",
                                                              {
                                                                staticClass:
                                                                  "invoice-total-amount",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      _vm.selectedCurrencySign
                                                                    ) +
                                                                    " " +
                                                                    _vm._s(
                                                                      _vm.subTotal.toFixed(
                                                                        2
                                                                      )
                                                                    ) +
                                                                    " "
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "invoice-total-item",
                                                          },
                                                          [
                                                            _c(
                                                              "p",
                                                              {
                                                                staticClass:
                                                                  "invoice-total-title",
                                                              },
                                                              [_vm._v("VAT:")]
                                                            ),
                                                            _c(
                                                              "p",
                                                              {
                                                                staticClass:
                                                                  "invoice-total-amount",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      _vm.selectedCurrencySign
                                                                    ) +
                                                                    " " +
                                                                    _vm._s(
                                                                      _vm.VATtotal.toFixed(
                                                                        2
                                                                      )
                                                                    ) +
                                                                    " "
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                        _c("hr", {
                                                          staticClass: "my-50",
                                                        }),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "invoice-total-item",
                                                          },
                                                          [
                                                            _c(
                                                              "p",
                                                              {
                                                                staticClass:
                                                                  "invoice-total-title",
                                                              },
                                                              [_vm._v("Total:")]
                                                            ),
                                                            _c(
                                                              "p",
                                                              {
                                                                staticClass:
                                                                  "invoice-total-amount",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      _vm.selectedCurrencySign
                                                                    ) +
                                                                    " " +
                                                                    _vm._s(
                                                                      _vm.finalTotal
                                                                    ) +
                                                                    " "
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                        _c("hr", {
                                          staticClass: "invoice-spacing",
                                        }),
                                        _c(
                                          "b-card-body",
                                          {
                                            staticClass: "invoice-padding pt-0",
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass: "font-weight-bold",
                                              },
                                              [_vm._v("Note: ")]
                                            ),
                                            _c("b-form-textarea", {
                                              model: {
                                                value: _vm.note,
                                                callback: function ($$v) {
                                                  _vm.note = $$v
                                                },
                                                expression: "note",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        1429195897
                      ),
                    }),
                    _c(
                      "validation-observer",
                      { ref: "addProduct" },
                      [
                        _c(
                          "b-modal",
                          {
                            ref: "addProductModal",
                            attrs: {
                              id: "modal-addProduct",
                              "hide-footer": true,
                              centered: "",
                              title: "Add Product",
                            },
                          },
                          [
                            _c(
                              "b-form",
                              {
                                on: {
                                  submit: function ($event) {
                                    $event.preventDefault()
                                    return _vm.handleProdSubmit($event)
                                  },
                                },
                              },
                              [
                                _c(
                                  "b-row",
                                  [
                                    _c(
                                      "b-col",
                                      { attrs: { cols: "12" } },
                                      [
                                        _c(
                                          "b-form-group",
                                          [
                                            _c(
                                              "label",
                                              { attrs: { for: "name" } },
                                              [_vm._v("Name:")]
                                            ),
                                            _c("validation-provider", {
                                              attrs: {
                                                rules: "required",
                                                name: "name",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function (ref) {
                                                      var errors = ref.errors
                                                      return [
                                                        _c("b-form-input", {
                                                          attrs: {
                                                            id: "name",
                                                            type: "text",
                                                            placeholder: "Name",
                                                            required: "",
                                                          },
                                                          model: {
                                                            value: _vm.prodName,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.prodName = $$v
                                                            },
                                                            expression:
                                                              "prodName",
                                                          },
                                                        }),
                                                        errors.length
                                                          ? _c(
                                                              "small",
                                                              {
                                                                staticClass:
                                                                  "text-danger text-end",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    errors[0]
                                                                  )
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                false,
                                                248935954
                                              ),
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "b-row",
                                  [
                                    _c(
                                      "b-col",
                                      { attrs: { cols: "12" } },
                                      [
                                        _c(
                                          "b-form-group",
                                          [
                                            _c(
                                              "label",
                                              { attrs: { for: "qty" } },
                                              [_vm._v("Quantity:")]
                                            ),
                                            _c("validation-provider", {
                                              attrs: {
                                                rules: "required",
                                                name: "qty",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function (ref) {
                                                      var errors = ref.errors
                                                      return [
                                                        _c("b-form-input", {
                                                          attrs: {
                                                            id: "qty",
                                                            type: "number",
                                                            placeholder:
                                                              "Quantity",
                                                            required: "",
                                                          },
                                                          on: {
                                                            keypress: function (
                                                              $event
                                                            ) {
                                                              return _vm.allowOnlyNumbersprod(
                                                                $event
                                                              )
                                                            },
                                                          },
                                                          model: {
                                                            value: _vm.prodQty,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.prodQty = $$v
                                                            },
                                                            expression:
                                                              "prodQty",
                                                          },
                                                        }),
                                                        errors.length
                                                          ? _c(
                                                              "small",
                                                              {
                                                                staticClass:
                                                                  "text-danger text-end",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    errors[0]
                                                                  )
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                false,
                                                3058909937
                                              ),
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "b-row",
                                  [
                                    _c(
                                      "b-col",
                                      { attrs: { cols: "12" } },
                                      [
                                        _c(
                                          "b-form-group",
                                          [
                                            _c(
                                              "b-form-checkbox",
                                              {
                                                attrs: { id: "checkbox" },
                                                model: {
                                                  value: _vm.prodInHouse,
                                                  callback: function ($$v) {
                                                    _vm.prodInHouse = $$v
                                                  },
                                                  expression: "prodInHouse",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  " Product Manufactured InHouse "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "b-row",
                                  { staticClass: "justify-content-end" },
                                  [
                                    _c(
                                      "b-col",
                                      { attrs: { cols: "auto" } },
                                      [
                                        _c(
                                          "b-button",
                                          {
                                            directives: [
                                              {
                                                name: "ripple",
                                                rawName: "v-ripple.400",
                                                value:
                                                  "rgba(113, 102, 240, 0.15)",
                                                expression:
                                                  "'rgba(113, 102, 240, 0.15)'",
                                                modifiers: { 400: true },
                                              },
                                            ],
                                            attrs: { variant: "primary" },
                                            on: { click: _vm.addProduct },
                                          },
                                          [_vm._v(" Save ")]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "b-col",
                  {
                    staticClass: "invoice-actions mt-md-0 mt-2",
                    attrs: { cols: "12", md: "4", xl: "3" },
                  },
                  [
                    _c(
                      "b-card",
                      [
                        _c(
                          "b-button",
                          {
                            directives: [
                              {
                                name: "ripple",
                                rawName: "v-ripple.400",
                                value: "rgba(113, 102, 240, 0.15)",
                                expression: "'rgba(113, 102, 240, 0.15)'",
                                modifiers: { 400: true },
                              },
                            ],
                            style: _vm.loadingButton
                              ? { cursor: "not-allowed" }
                              : {},
                            attrs: {
                              variant: "outline-primary",
                              block: "",
                              disabled: _vm.loadingButton,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.addSalesOrder()
                              },
                            },
                          },
                          [
                            _vm.loading
                              ? _c("b-spinner", { attrs: { small: "" } })
                              : _vm._e(),
                            _vm._v(" Save "),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }